/* ============================================================
   EASTGATE, shared app (data, cart, chrome)
   Loaded on every page. Exposes window.EG for page scripts.
   ============================================================ */
(function(){
"use strict";

/* ---- product data ---- */
const SW={Pink:'#E8B4C0',Black:'#1A1A1A',Sand:'#C8A97E',Slate:'#5A6670',Navy:'#2A3645',
  Forest:'#2E4034',Cream:'#EDE6D8',Charcoal:'#36383B',Walnut:'#6B4F3A',White:'#FFFFFF',
  Lavender:'#C9C2DD',Grey:'#9A9A9A'};

const PRODUCTS=[
 {id:'p01',cat:'Dogs · Walk',name:'Urban Dog Harness',price:'€54,95',badge:['best','Best seller'],desc:'Soft-stretch mesh, 3 leash link points, S–XL.',colors:['Pink','Black','Sand','Slate','Navy','Forest'],extra:2,specs:[['Material','Soft-stretch air mesh'],['Link points','3 (front, back, dual)'],['Sizes','S / M / L / XL'],['Care','Machine washable']]},
 {id:'p02',cat:'Dogs · Walk',name:'Hands-Free Rope Leash',price:'€37,95',badge:['best','Best seller'],desc:'Weatherproof coating, adjustable length, brass hardware.',colors:['Black','Sand','Forest','Slate'],extra:3,specs:[['Length','Adjustable 1.2–1.8m'],['Hardware','Solid brass'],['Coating','Weatherproof'],['Wear','Crossbody or handheld']]},
 {id:'p03',cat:'Dogs · Walk',name:'Harness + Leash Walk Kit',price:'€89,95',was:'€96,95',badge:['save','Save €7'],desc:'Harness, leash & poop bag carrier, a matched set, ready to walk.',colors:[],specs:[['Includes','Harness, leash, bag carrier'],['Saving','€7 vs separate'],['Sizes','S / M / L / XL'],['Finish','Matched colourway']]},
 {id:'p04',cat:'Dogs · Walk',name:'Reflective Dog Collar',price:'€19,95',badge:['new','New'],desc:'Waterproof, night-visible, quick-release buckle.',colors:['Black','Sand','Forest','Navy'],specs:[['Material','Coated waterproof webbing'],['Visibility','Reflective stitching'],['Buckle','Quick-release'],['Sizes','S / M / L']]},
 {id:'p05',cat:'Dogs · Home',name:'Memory Foam Pet Bed',price:'€99,95',badge:['best','Best seller'],desc:'Orthopaedic foam, washable cover, S/M/L.',colors:['Cream','Charcoal','Walnut'],specs:[['Fill','Orthopaedic memory foam'],['Cover','Removable, washable'],['Base','Non-slip'],['Sizes','S / M / L']]},
 {id:'p06',cat:'Dogs · Home',name:'Slow Feeder Bowl',price:'€19,95',badge:null,desc:'Anti-bloat design, non-slip base, dishwasher safe.',colors:['White','Black'],specs:[['Design','Maze, anti-bloat'],['Base','Non-slip ring'],['Care','Dishwasher safe'],['Capacity','350ml']]},
 {id:'p07',cat:'Dogs · Home',name:'Rope Toy Bundle (3-pack)',price:'€24,95',badge:null,desc:'Natural cotton, 3 styles, for S/L dogs.',colors:[],specs:[['Material','Natural cotton rope'],['Count','3 toys'],['Styles','Knot, ring, tug'],['For','S to L dogs']]},
 {id:'p08',cat:'Cats',name:'Cat Harness & Leash',price:'€39,95',badge:['new','New'],desc:'Escape-proof H-design, S/M + Kitten sizing.',colors:['Pink','Lavender','Black'],specs:[['Design','Escape-proof H-frame'],['Includes','Harness + leash'],['Sizes','Kitten / S / M'],['Adjust','4-point']]},
 {id:'p09',cat:'Cats',name:'Cat Carrier Backpack',price:'€79,95',badge:['best','Best seller'],desc:'Airline approved, mesh ventilation, up to 6kg.',colors:['Black','Sand'],specs:[['Capacity','Up to 6kg'],['Ventilation','Mesh panels'],['Travel','Airline approved'],['Carry','Backpack straps']]},
 {id:'p10',cat:'Cats',name:'Cat Water Fountain',price:'€49,95',badge:['new','New'],desc:'Silent pump, 1.5L, triple carbon filtration.',colors:['White','Black'],specs:[['Capacity','1.5L'],['Pump','Silent <30dB'],['Filter','Triple carbon'],['Power','USB']]},
 {id:'p11',cat:'Cats',name:'Heated Cat Bed',price:'€69,95',badge:['new','New'],desc:'Auto temp control 38°C, washable fleece, S/L.',colors:['Cream','Grey'],specs:[['Temp','Auto 38°C'],['Cover','Washable fleece'],['Safety','Auto cut-off'],['Sizes','S / L']]},
 {id:'p12',cat:'Travel',name:'Airline Pet Carrier',price:'€114,95',badge:['best','Best seller'],desc:'IATA compliant, fits under seat, up to 7kg.',colors:['Black','Sand'],specs:[['Standard','IATA compliant'],['Fit','Under-seat'],['Capacity','Up to 7kg'],['Ventilation','4-side mesh']]},
 {id:'p13',cat:'Travel · Smart',name:'GPS Pet Tracker',price:'€99,95',badge:['new','New'],desc:'Real-time EU coverage, 7-day battery, app-controlled.',colors:['Black','White'],specs:[['Coverage','Real-time EU'],['Battery','Up to 7 days'],['Control','iOS / Android app'],['Water','IPX7']]},
 {id:'p14',cat:'Travel',name:'Collapsible Travel Bowl Set',price:'€19,95',badge:null,desc:'2-pack, 600ml each, carabiner clip.',colors:['Sand','Black'],specs:[['Count','2-pack'],['Capacity','600ml each'],['Clip','Carabiner'],['Material','Food-grade silicone']]},
 {id:'p15',cat:'Travel',name:'Portable Water Bottle',price:'€32,95',badge:null,desc:'500ml, one-hand operation, leak-proof.',colors:['Black','Sand','Forest'],specs:[['Capacity','500ml'],['Use','One-hand'],['Seal','Leak-proof'],['Includes','Drain return']]},
 {id:'p16',cat:'Smart Tech',name:'Auto Pet Feeder',price:'€149,95',badge:['new','New'],desc:'App-controlled, 4L hopper, 6 scheduled meals/day.',colors:['White','Black'],specs:[['Hopper','4L'],['Meals','Up to 6/day'],['Control','App + manual'],['Backup','Battery']]},
 {id:'p17',cat:'Smart Tech',name:'HD Pet Camera',price:'€174,95',badge:['new','New'],desc:'1080p, 2-way audio, treat dispenser, app-controlled.',colors:['White','Black'],specs:[['Video','1080p HD'],['Audio','2-way'],['Treats','Toss dispenser'],['Vision','Night mode']]},
 {id:'p18',cat:'Smart Tech',name:'Smart LED Safety Collar',price:'€44,95',badge:['new','New'],desc:'USB rechargeable, 3 modes (steady/flash/pulse), IPX6.',colors:['Black','Sand','Forest'],specs:[['Modes','Steady / flash / pulse'],['Charge','USB rechargeable'],['Water','IPX6'],['Runtime','Up to 12h']]},
];
const P=Object.fromEntries(PRODUCTS.map(p=>[p.id,p]));
const GROUPS={
  fav:['p01','p02','p03','p04','p05','p06','p07','p12'],
  cats:['p08','p09','p10','p11'],
  tech:['p13','p14','p15','p16','p17','p18'],
  kits:['p03','p13','p02','p15','p09'],
};

/* Payment methods, SVGs in pay-<file>.svg */
const PAY=[
 ['visa','Visa'],['mastercard','Mastercard'],['amex','American Express'],['paypal','PayPal']
];

/* ---- helpers ---- */
const imgA=id=>`${window.EG_ASSETS}${id}-a.jpg`;
const imgB=id=>`${window.EG_ASSETS}${id}-b.jpg`;
const priceNum=p=>parseFloat(String(p.price).replace(/[^0-9,]/g,'').replace(',','.'))||0;
const formatEUR=n=>'€'+n.toFixed(2).replace('.',',');

function swatches(c,extra){
  if(!c||!c.length) return '';
  let dots=c.slice(0,4).map(n=>`<span class="swatch" style="background:${SW[n]||'#ccc'}" title="${n}"></span>`).join('');
  const left=(c.length-4)+(extra||0);
  if(left>0) dots+=`<span class="swatch--more">+${left}</span>`;
  return `<div class="swatches">${dots}</div>`;
}
function card(p){
  const badge=p.badge?`<span class="card__badge card__badge--${p.badge[0]}">${p.badge[1]}</span>`:'';
  const was=p.was?`<span class="card__was">${p.was}</span>`:'';
  return `<article class="card reveal">
    <a class="card__media" href="/products/${EG_HANDLE[p.id]}" aria-label="${p.name}">
      ${badge}
      <img class="a" src="${imgA(p.id)}" alt="${p.name}" loading="lazy">
      <button class="card__add" data-add="${p.id}" type="button">Quick add</button>
    </a>
    <a href="/products/${EG_HANDLE[p.id]}" class="card__cat label label--sand">${p.cat}</a>
    <h3 class="card__name"><a href="/products/${EG_HANDLE[p.id]}">${p.name}</a></h3>
    <p class="card__desc">${p.desc}</p>
    <div class="card__foot">
      <div class="card__price">${p.price}${was}</div>
      ${swatches(p.colors,p.extra)}
    </div>
  </article>`;
}

/* ---- cart (localStorage) ---- */
const KEY='eg_cart_v1';
function getCart(){
  try{return JSON.parse(localStorage.getItem(KEY))||[];}catch(e){return [];}
}
function saveCart(c){localStorage.setItem(KEY,JSON.stringify(c));sync();}
function addToCart(id,qty){
  qty=qty||1;const c=getCart();const row=c.find(i=>i.id===id);
  if(row)row.qty+=qty;else c.push({id,qty});
  saveCart(c);
}
function setQty(id,qty){
  let c=getCart();const row=c.find(i=>i.id===id);
  if(!row)return;row.qty=qty;if(row.qty<1)c=c.filter(i=>i.id!==id);
  saveCart(c);
}
function removeItem(id){saveCart(getCart().filter(i=>i.id!==id));}
const cartCount=()=>getCart().reduce((n,i)=>n+i.qty,0);
const cartTotal=()=>getCart().reduce((n,i)=>n+priceNum(P[i.id])*i.qty,0);

/* ---- chrome markup ---- */
function headerHTML(){
  return `<div class="announce"><div class="announce__viewport">
    <div class="announce__msg">Free delivery on orders €60+ · <a href="/#shop">Shop now</a></div>
    <div class="announce__msg">Smart pet tech, new arrivals this week · <a href="/#tech">Explore</a></div>
    <div class="announce__msg">Airline-approved carriers in stock · <a href="/#tech">View carriers</a></div>
  </div></div>
  <header class="header"><div class="wrap header__inner">
    <nav class="header__nav header__nav--left">
      <a href="/#shop">Dogs</a><a href="/#cats">Cats</a><a href="/#tech">Travel</a>
    </nav>
    <button class="hamburger iconbtn" aria-label="Open menu" id="navOpen"><svg viewBox="0 0 24 24"><path d="M3 6h18M3 12h18M3 18h18"/></svg></button>
    <a href="/" class="brand" aria-label="Eastgate Commerce Limited"><img src="${window.EG_ASSETS}eastgate-logo.png" alt="Eastgate Commerce Limited" class="brand-logo"></a>
    <div class="header__actions">
      <button class="iconbtn" aria-label="Search"><svg viewBox="0 0 24 24"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4-4"/></svg></button>
      <button class="iconbtn cart" aria-label="Cart" data-open-cart><svg viewBox="0 0 24 24"><path d="M6 7h12l-1 13H7L6 7z"/><path d="M9 7a3 3 0 0 1 6 0"/></svg><span class="cart__count">0</span></button>
    </div>
  </div></header>
  <div class="mobilenav" id="mobilenav">
    <div class="mobilenav__top"><span class="brand"><img src="${window.EG_ASSETS}eastgate-logo.png" alt="Eastgate Commerce Limited" class="brand-logo"></span>
      <button class="iconbtn" aria-label="Close menu" id="navClose"><svg viewBox="0 0 24 24"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div>
    <a href="/#shop">Dogs</a><a href="/#cats">Cats</a><a href="/#tech">Travel &amp; Smart Tech</a>
    <a href="/pages/story">Why Eastgate</a><a href="/#reviews">Reviews</a>
  </div>`;
}
function payRow(){return PAY.map(([f,n])=>`<img src="${window.EG_ASSETS}pay-${f}.svg" alt="${n}" title="${n}" loading="lazy">`).join('');}
function footerHTML(){
  return `<footer class="footer"><div class="wrap">
    <div class="footer__grid">
      <div class="footer__brand"><span class="brand"><img src="${window.EG_ASSETS}eastgate-logo.png" alt="Eastgate Commerce Limited" class="brand-logo brand-logo--footer"></span>
        <p>Premium pet gear, designed to human standards and tested across Europe.</p></div>
      <div><h4>Shop</h4><ul>
        <li><a href="/#shop">Dogs</a></li><li><a href="/#cats">Cats</a></li>
        <li><a href="/#tech">Travel</a></li><li><a href="/#tech">Smart Tech</a></li></ul></div>
      <div><h4>Info</h4><ul>
        <li><a href="/pages/story">Our story</a></li><li><a href="/pages/sustainability">Sustainability</a></li>
        <li><a href="/pages/stockists">Stockists</a></li></ul></div>
      <div><h4>Help</h4><ul>
        <li><a href="/pages/shipping">Shipping</a></li><li><a href="/pages/returns">Returns</a></li>
        <li><a href="/pages/size-guide">Size guide</a></li><li><a href="/pages/contact">Contact</a></li></ul></div>
      <div class="footer__news"><h4>Newsletter</h4>
        <p>New arrivals and members-only offers. No noise.</p>
        <form class="news__row" id="newsForm"><input type="email" placeholder="Your email" aria-label="Email" required>
          <button class="btn btn--solid" type="submit">Join</button></form>
        <div class="news__msg" id="newsMsg"></div></div>
    </div>
    <nav class="footer__legal" aria-label="Legal">
      <a href="/pages/privacy">Privacy Policy</a>
      <a href="/pages/terms">Terms of Service</a>
      <a href="/pages/refund">Refund Policy</a>
      <a href="/pages/shipping">Shipping Policy</a>
      <a href="/pages/cookie">Cookie Policy</a>
    </nav>
    <div class="footer__company">
      EASTGATE COMMERCE LIMITED · Company No. 80728777<br>
      Flat 2304, 23/F, Ho King Commercial Centre, 2-16 Fa Yuen Street, Mong Kok, Hong Kong
    </div>
    <div class="footer__bottom">
      <small>© 2025 Eastgate Commerce Limited</small>
      <div class="pays">${payRow()}</div>
    </div>
  </div></footer>`;
}
function drawerHTML(){
  return `<div class="drawer-overlay" data-close-cart></div>
  <aside class="drawer" id="egDrawer" aria-label="Cart">
    <div class="drawer__head"><span class="drawer__title">Your cart</span>
      <button class="iconbtn" aria-label="Close cart" data-close-cart><svg viewBox="0 0 24 24"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div>
    <div class="drawer__items" id="egDrawerItems"></div>
    <div class="drawer__foot" id="egDrawerFoot"></div>
  </aside>`;
}

/* ---- drawer render ---- */
function ditem(i){
  const p=P[i.id];
  return `<div class="ditem">
    <img class="ditem__img" src="${imgA(p.id)}" alt="${p.name}">
    <div>
      <div class="ditem__name">${p.name}</div>
      <div class="ditem__cat">${p.cat}</div>
      <div class="ditem__row">
        <div class="qty"><button data-dec="${p.id}" aria-label="Decrease">−</button><span>${i.qty}</span><button data-inc="${p.id}" aria-label="Increase">+</button></div>
        <div class="ditem__price">${formatEUR(priceNum(p)*i.qty)}</div>
      </div>
      <button class="ditem__remove" data-remove="${p.id}">Remove</button>
    </div>
  </div>`;
}
/* ---- Shopify hosted checkout ---- */
const EG_HANDLE={"p01":"urban-dog-harness","p02":"hands-free-rope-leash","p03":"harness-leash-walk-kit","p04":"reflective-dog-collar","p05":"memory-foam-pet-bed","p06":"slow-feeder-bowl","p07":"rope-toy-bundle-3-pack","p08":"cat-harness-leash","p09":"cat-carrier-backpack","p10":"cat-water-fountain","p11":"heated-cat-bed","p12":"airline-pet-carrier","p13":"gps-pet-tracker","p14":"collapsible-travel-bowl-set","p15":"portable-water-bottle","p16":"auto-pet-feeder","p17":"hd-pet-camera","p18":"smart-led-safety-collar"};
const EG_VAR=window.EG_VAR={p01:57629620470142,p02:57629620633982,p03:57629620765054,p04:57629620928894,p05:57629620994430,p06:57629621059966,p07:57629621453182,p08:57629621485950,p09:57629621518718,p10:57629621617022,p11:57629621649790,p12:57629621682558,p13:57629621813630,p14:57629621846398,p15:57629623452030,p16:57629623484798,p17:57629623517566,p18:57629623550334};
function shopifyCheckoutURL(){
  const parts=getCart().filter(i=>EG_VAR[i.id]).map(i=>EG_VAR[i.id]+':'+i.qty);
  return parts.length?`/cart/${parts.join(',')}`:'/';
}
function renderDrawer(){
  const items=document.getElementById('egDrawerItems');
  const foot=document.getElementById('egDrawerFoot');
  if(!items||!foot)return;
  const c=getCart();
  if(!c.length){
    items.innerHTML='<p class="drawer__empty">Your cart is empty.<br>Add something they’ll love.</p>';
    foot.innerHTML='';return;
  }
  items.innerHTML=c.map(ditem).join('');
  const total=cartTotal();
  const ship=total>=60?'Free':'€5,95';
  foot.innerHTML=`<div class="drawer__sub"><span>Subtotal</span><span>${formatEUR(total)}</span></div>
    <div class="drawer__ship">Shipping: ${ship} · ${total>=60?'qualifies for free delivery':'free over €60'}</div>
    <a class="btn btn--solid" href="${shopifyCheckoutURL()}">Checkout</a>
    <button class="drawer__cont" data-close-cart type="button">Continue shopping</button>`;
}
function openDrawer(){renderDrawer();document.querySelector('.drawer-overlay').classList.add('is-open');document.getElementById('egDrawer').classList.add('is-open');}
function closeDrawer(){document.querySelector('.drawer-overlay').classList.remove('is-open');document.getElementById('egDrawer').classList.remove('is-open');}

/* ---- keep all UI in sync with cart ---- */
function sync(){
  document.querySelectorAll('.cart__count').forEach(el=>el.textContent=cartCount());
  renderDrawer();
}

/* ---- boot ---- */
function injectInto(sel,html){const el=document.querySelector(sel);if(el)el.innerHTML=html;}
document.addEventListener('DOMContentLoaded',function(){
  injectInto('[data-eg="header"]',headerHTML());
  injectInto('[data-eg="footer"]',footerHTML());
  const d=document.createElement('div');d.innerHTML=drawerHTML();while(d.firstChild)document.body.appendChild(d.firstChild);

  /* render any product groups on the page */
  document.querySelectorAll('[data-products]').forEach(el=>{
    const g=GROUPS[el.dataset.products];if(g)el.innerHTML=g.map(id=>card(P[id])).join('');
  });

  sync();

  /* mobile nav */
  const mnav=document.getElementById('mobilenav');
  const open=document.getElementById('navOpen'),close=document.getElementById('navClose');
  if(open)open.onclick=()=>mnav.classList.add('is-open');
  if(close)close.onclick=()=>mnav.classList.remove('is-open');
  if(mnav)mnav.querySelectorAll('a').forEach(a=>a.onclick=()=>mnav.classList.remove('is-open'));

  /* delegated clicks: open/close cart, qty, remove, quick-add */
  document.addEventListener('click',function(e){
    const t=e.target;
    if(t.closest('[data-open-cart]')){e.preventDefault();openDrawer();return;}
    if(t.closest('[data-close-cart]')){closeDrawer();return;}
    const inc=t.closest('[data-inc]');if(inc){const id=inc.dataset.inc;const r=getCart().find(i=>i.id===id);setQty(id,(r?r.qty:0)+1);return;}
    const dec=t.closest('[data-dec]');if(dec){const id=dec.dataset.dec;const r=getCart().find(i=>i.id===id);setQty(id,(r?r.qty:1)-1);return;}
    const rm=t.closest('[data-remove]');if(rm){removeItem(rm.dataset.remove);return;}
    const add=t.closest('[data-add]');
    if(add){e.preventDefault();
      addToCart(add.dataset.add,1);openDrawer();
      add.classList.add('is-added');add.textContent='Added ✓';
      setTimeout(()=>{add.classList.remove('is-added');add.textContent='Quick add';},1400);
    }
  });

  /* newsletter */
  const nf=document.getElementById('newsForm');
  if(nf)nf.addEventListener('submit',e=>{e.preventDefault();e.target.reset();
    const m=document.getElementById('newsMsg');if(m)m.textContent='Thanks, you’re on the list.';});

  /* scroll reveal */
  const io=new IntersectionObserver((en)=>{en.forEach(x=>{if(x.isIntersecting){x.target.classList.add('is-visible');io.unobserve(x.target);}});},{threshold:.12});
  const markReveal=()=>document.querySelectorAll('.reveal:not(.is-visible)').forEach(el=>io.observe(el));
  markReveal();window.EG&&(window.EG._markReveal=markReveal);
});

/* ---- expose for page scripts (PDP, checkout) ---- */
window.EG={PRODUCTS,P,GROUPS,SW,PAY,card,swatches,imgA,imgB,priceNum,formatEUR,
  getCart,addToCart,setQty,removeItem,cartCount,cartTotal,openDrawer,closeDrawer,renderDrawer,shopifyCheckoutURL,
  _markReveal:null};
})();
